import React from "react";
import { OrderHistoryProgressStepper } from "@/features/my-order/features/order-history/components/progress-section/OrderHistoryProgressStepper";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import { convertOrderStatusToNew } from "@/shared/utils";
import { NewOrderStatus } from "@/shared/types";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

type StepperUI = {
  currentIndex: number;
  isCancelled?: boolean;
  isRequired?: boolean;
  isCompleted?: boolean;
};

const statusToStepperUI: Partial<Record<NewOrderStatus, StepperUI>> = {
  ORDER_SUBMITTED: {
    currentIndex: 0.08,
  },
  ORDER_CONSULTING: {
    currentIndex: 1.04,
  },
  BUYER_MODIFICATION_REQUIRED: {
    currentIndex: 1.04,
    isRequired: true,
  },
  RESUBMIT_COMPLETED: {
    currentIndex: 1.04,
  },
  BUYER_CONFIRM_REQUIRED: {
    currentIndex: 1.04,
    isRequired: true,
  },
  ORDER_CONFIRMED: {
    currentIndex: 2.01,
  },
  TRANSPORTATION_ING: {
    currentIndex: 3,
  },
  TRANSPORTATION_COMPLETED: {
    currentIndex: 4,
  },
  COMPLETED: {
    currentIndex: 5,
    isCompleted: true,
  },
  ORDER_CANCELED: {
    currentIndex: 0,
    isCancelled: true,
  },
};

function OrderHistoryProgressSection() {
  const { data } = useOrderHistoryDetail();
  const status = convertOrderStatusToNew(
    data?.status ?? "WORKING_DRAFT"
  ) as NewOrderStatus;
  const { tSentence, tTitle } = useI18nHelper();

  return (
    <OrderHistoryProgressStepper
      title={tTitle("order_history:progress")}
      currentIndex={statusToStepperUI[status]?.currentIndex ?? 0}
      message={tSentence(
        "order_history:progress.msg." + status.toLowerCase() ?? ""
      )}
      steps={[
        { id: "1", label: tTitle("order_history:progress.order_submitted") },
        { id: "2", label: tTitle("order_history:order_consulting") },
        { id: "3", label: tTitle("order_history:order_confirmed") },
        { id: "4", label: tTitle("order_history:transportation_ing") },
        { id: "5", label: tTitle("order_history:transportation_completed") },
        { id: "6", label: tTitle("order_history:completed") },
      ]}
      isRequired={statusToStepperUI[status]?.isRequired}
      isCancelled={statusToStepperUI[status]?.isCancelled}
      isCompleted={statusToStepperUI[status]?.isCompleted}
    />
  );
}

export default OrderHistoryProgressSection;
